import React from "react";
import TextInput from "components/inputs/textInput";
import SelectInput from "components/inputs/selectInput";
import { TransactionsSortBy } from "@/hooks/useTransactions";
import { SortDirection } from "@/types";
import Collapse from "../collapse/Collapse";
import { useTranslation } from 'react-i18next';
import { ReactComponent as FilterIcon } from "assets/icons/filter.svg";
import InputGroup from "../inputs/InputGroup";

interface TransactionFilterProps {
	filterQuery: string;
	setFilterQuery: (v: string) => void;
	sortBy: TransactionsSortBy;
	setSortBy: (v: TransactionsSortBy) => void;
	sortDirection: SortDirection;
	setSortDirection: (v: SortDirection) => void;
	typeFilter?: string;
	setTypeFilter?: (v: string) => void;
	isLoading?: boolean;
}

const TransactionFilter: React.FC<TransactionFilterProps> = ({
	filterQuery,
	setFilterQuery,
	sortBy,
	setSortBy,
	sortDirection,
	setSortDirection,
	typeFilter,
	setTypeFilter,
	isLoading,
}) => {

	const { t } = useTranslation();

	return (
		<div className="flex flex-col gap-y-4">
			<Collapse textOpen={t(`labelHideFilters`)} textClosed={t(`labelShowFilters`)} icon={<FilterIcon />}>
				<TextInput
					label="Filter keywords"
					value={filterQuery}
					onChange={e => setFilterQuery(e.target.value)}
					disabled={isLoading}
				/>
				{typeFilter !== undefined && setTypeFilter && (
					<SelectInput
						label={t('labelType')}
						value={typeFilter}
						onChange={e => setTypeFilter(e.target.value)}
						disabled={isLoading}
					>
						<option value="all">{t('labelAll')}</option>
						<option value="incoming">{t('labelIncoming')}</option>
						<option value="outgoing">{t('labelOutgoing')}</option>
					</SelectInput>
				)}
				<InputGroup>
					<SelectInput
						label="Sort by"
						value={sortBy}
						onChange={e => setSortBy(e.target.value as TransactionsSortBy)}
						disabled={isLoading}
					>
						{Object.values(TransactionsSortBy).map(field => (
							<option key={field} value={field}>
								{field.charAt(0).toUpperCase() + field.slice(1)}
							</option>
						))}
					</SelectInput>
					<SelectInput
						label="Sort direction"
						value={sortDirection}
						onChange={e => setSortDirection(e.target.value as SortDirection)}
						disabled={isLoading}
					>
						<option value="asc">Ascending</option>
						<option value="desc">Descending</option>
					</SelectInput>
				</InputGroup>
			</Collapse>
		</div>
	);
};

export default TransactionFilter;
